import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';

const buildRewardsPageView = (pageName) => ({
    eventName: 'pageView',
    payload: buildCJAPageViewPayload(
        {
            name: pageName,
            type: 'rewards',
            siteSection: 'rewards',
            category: { primary: 'account' },
            tech: { version: 'apollo 1 2017 redesign yoda account' },
        },
        {},
        { interactionName: 'regular_pageview' }
    ),
});

export default buildRewardsPageView;
